const recommendationsInternalScreenPopUpMessages = {
  emptyData:
    'The chosen group does not have any recommended actions to take at present',
  downloadCSV: 'Download CSV',
  downloadExcel: 'Download Excel',
  downloadCSVMessage: 'CSV File will get downloaded.',
  downloadExcelMessage: 'Excel File will get downloaded.',
};

export default recommendationsInternalScreenPopUpMessages;
